import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { TokenCookieService } from "src/app/core/service/token-storage-cookies.service";
import Swal from "sweetalert2";
import { ROUTES } from "./sidebar-items";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() isMobile = false;
  @Output() navigateItem = new EventEmitter<void>();

  public sidebarItems: any[] = [];
  userFullName: string;
  userImg: string;
  currentUser: any;
  userName = "";
  userRole = "";
  expandedModuleName = "";
  private routerSubscription: Subscription;

  constructor(
    private tokenCookieService: TokenCookieService,
    private router: Router
  ) {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currenturl = event.url.split("?")[0];
        const activeRoot = currenturl.split("/").filter(Boolean)[0] || "";
        const expandedGroup = ROUTES.find((item) =>
          item.submenu?.some((submenu) => submenu.path.includes(`/${activeRoot}`))
        );

        this.expandedModuleName = expandedGroup?.moduleName || activeRoot;
      }
    });
  }

  ngOnInit() {
    this.currentUser = this.tokenCookieService.getUser();

    if (this.currentUser) {
      this.userName = this.currentUser.username;
      this.userRole = "Supplier";
      this.userFullName = this.currentUser.username;
      this.userImg = "assets/images/user/profile_img.png";

      const userRole = "Supplier";
      this.sidebarItems = ROUTES.filter(
        (x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf("All") !== -1
      );
    }
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  isExpanded(item: any): boolean {
    return this.expandedModuleName === item.moduleName;
  }

  toggleGroup(item: any): void {
    this.expandedModuleName =
      this.expandedModuleName === item.moduleName ? "" : item.moduleName;
  }

  onLeafClick(): void {
    this.navigateItem.emit();
  }

  logout(): void {
    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to Exit?",
      showCancelButton: true,
      confirmButtonText: "Yes, exit!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(["/supplier-authentication/signin"]);
      }
    });
  }
}
